/**
 * グループオプション - 表示制御ルール
 * 印刷色数に基づくオプション表示/非表示の制御
 */

(function() {
  'use strict';

  // 名前空間の初期化
  window.GroupedOptionsVisibility = window.GroupedOptionsVisibility || {};

  /**
   * オプション表示条件ルールを読み込む
   * Metaobjectからのルールを優先、なければハードコードのフォールバック
   * @returns {Array} ルール配列
   */
  function loadVisibilityRules() {
    // 色タイプ選択は印刷色数モーダル内で行うため、「カラーの選択」オプションは常に非表示
    // 2026-01-27: color-type-selector.js と price-calculator-modals.js で色選択UIを統合
    var colorSelectionHideRule = {
      triggerPattern: /.*/,  // 全ての印刷色数にマッチ
      showOptions: [],
      hideOptions: ['カラーの選択【表面】', 'カラーの選択【裏面】', 'カラーの選択（表面）', 'カラーの選択（裏面）', 'カラーの選択'],
      filterChoices: []
    };

    // Metaobjectから読み込んだルールがあれば使用（カラー選択非表示ルールを追加）
    if (window.optionVisibilityRules && window.optionVisibilityRules.length > 0) {
      var rules = window.optionVisibilityRules.map(function(rule) {
        return {
          triggerPattern: new RegExp(rule.triggerPattern),
          showOptions: rule.showOptions || [],
          hideOptions: rule.hideOptions || [],
          filterChoices: rule.filterChoices || []
        };
      });
      // カラー選択非表示ルールを先頭に追加
      return [colorSelectionHideRule].concat(rules);
    }

    // フォールバック: カラー選択は常に非表示
    return [colorSelectionHideRule];
  }

  /**
   * 現在の印刷色数を取得
   * @returns {string|null}
   */
  function getCurrentPrintColor() {
    if (window.priceCalculator && window.priceCalculator.currentSelection) {
      return window.priceCalculator.currentSelection.printColor;
    }
    return null;
  }

  /**
   * 印刷色数に基づくルールを取得
   * @param {string} printColor - 印刷色数
   * @param {Array} rules - ルール配列
   * @returns {Object|null}
   */
  function getColorVisibilityRule(printColor, rules) {
    if (!printColor || !rules) return null;
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].triggerPattern.test(printColor)) {
        return rules[i];
      }
    }
    return null;
  }

  /**
   * オプションが表示対象かどうか判定
   * @param {Object} option - オプション
   * @param {Object} rule - 表示ルール
   * @returns {boolean}
   */
  function isOptionVisible(option, rule) {
    // option.label または option.name のどちらかを使用
    var optionLabel = option.label || option.name || '';

    // 「カラーの選択」オプションは常に非表示（印刷色数モーダルで選択するため）
    // ルールに関係なく非表示にする
    // 2026-01-27: color-type-selector.js と price-calculator-modals.js で色選択UIを統合
    var colorSelectionPatterns = ['カラーの選択【表面】', 'カラーの選択【裏面】', 'カラーの選択（表面）', 'カラーの選択（裏面）', 'カラーの選択'];
    for (var j = 0; j < colorSelectionPatterns.length; j++) {
      if (optionLabel.includes(colorSelectionPatterns[j])) {
        return false;
      }
    }

    if (!rule) return true;

    // 非表示リストに含まれる場合
    for (var i = 0; i < rule.hideOptions.length; i++) {
      if (optionLabel.includes(rule.hideOptions[i])) {
        return false;
      }
    }
    return true;
  }

  /**
   * 再生紙などの素材制約をチェック
   * @returns {Object|null} 素材制約情報
   */
  function getMaterialConstraint() {
    var tags = [];

    // productDataからタグを取得
    if (window.productData && window.productData.tags) {
      tags = window.productData.tags;
    }

    // material:recycled タグがある場合、ブラックのみ許可
    var isRecycled = tags.some(function(tag) {
      return tag === 'material:recycled' || tag.includes('material:recycled');
    });

    if (isRecycled) {
      return {
        type: 'recycled',
        allowedColors: ['K', 'ブラック']
      };
    }

    return null;
  }

  /**
   * 選択肢がフィルター対象かどうか判定
   * @param {Object} choice - 選択肢
   * @param {Object} rule - 表示ルール
   * @param {Function} normalizeChoice - 正規化関数
   * @returns {boolean}
   */
  function isChoiceAllowed(choice, rule, normalizeChoice) {
    if (!rule || !rule.filterChoices || rule.filterChoices.length === 0) {
      return true;
    }

    var normalizedChoice = normalizeChoice(choice);
    var label = normalizedChoice.label || '';

    // 「CMYK（フルカラー）」や「裏面の選択はできません」は1色印刷では除外
    if (label.includes('CMYK') || label.includes('フルカラー')) {
      return false;
    }
    if (label.includes('裏面の選択はできません') || label.includes('表面の選択はできません')) {
      return false;
    }

    // ★ 素材制約チェック（再生紙等）
    var materialConstraint = getMaterialConstraint();
    if (materialConstraint) {
      // 素材制約がある場合、許可された色のみ
      var isAllowedByMaterial = materialConstraint.allowedColors.some(function(color) {
        return label.includes(color) || label.startsWith(color);
      });
      if (!isAllowedByMaterial) {
        return false;
      }
    }

    // フィルターパターンのいずれかにマッチすれば許可
    for (var i = 0; i < rule.filterChoices.length; i++) {
      var pattern = rule.filterChoices[i];
      if (label.includes(pattern) || label.startsWith(pattern)) {
        return true;
      }
    }
    return false;
  }

  // エクスポート
  window.GroupedOptionsVisibility = {
    loadVisibilityRules: loadVisibilityRules,
    getCurrentPrintColor: getCurrentPrintColor,
    getColorVisibilityRule: getColorVisibilityRule,
    isOptionVisible: isOptionVisible,
    isChoiceAllowed: isChoiceAllowed,
    getMaterialConstraint: getMaterialConstraint
  };

})();

